import { Toast } from 'antd-mobile';
import { get, post, put, put2, postForm, headers, urlPreFix } from '@/utils/request';
import { fetchEventSource } from '@microsoft/fetch-event-source';
import { getUrlParams } from '@/utils/env';
import { aesDecrypt, aesEncrypt, h5Id, JSONParse, randomStr } from '@/utils/encrypt';

/**
 * 提问
 * @param {object} params
 * @param {Array} params.messages 消息体
 * @returns
 */
export const ask = (params) => {
  const formData = new FormData();

  if (!params.gptType) {
    params.gptType = getUrlParams('gpttype') || 0;
  }

  for (const key in params) {
    const value = params[key];
    try {
      // 更严格的类型检查
      if (value !== 'undefined' && value !== undefined && value !== null) {
        // 处理特殊类型
        if (value instanceof File || value instanceof Blob) {
          formData.append(key, value);
        } else if (typeof value === 'object') {
          // 对象类型转换为字符串
          formData.append(key, JSON.stringify(value));
        } else {
          // 基本类型直接添加
          formData.append(key, String(value));
        }
      }
    } catch (error) {
      console.warn(`处理参数 ${key} 时出错:`, error);
      // 跳过错误的参数，继续处理其他参数
      continue;
    }
  }

  return post('/v1/aichat/sendMsg', formData, { requestType: 'form' });
};

// 发送聊天-流式响应
export const sendChatMsgStream = (sendData, handleResponse) =>
  new Promise((resolve, reject) => {
    const { params = {}, options = {} } = sendData || {};
    let index = 0;
    fetchEventSource(`/v7/${randomStr()}?v=${aesEncrypt('aichat/msgTask/sendStreamingMsg')}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        appId: h5Id,
        ...headers
      },
      body: JSON.stringify({
        v: aesEncrypt(params)
      }),
      onopen: (res) => {
        index = 0;
        if (res.status !== 200) {
          reject(res);
        }
      },
      onmessage: (res) => {
        let resData = null;

        try {
          resData = typeof res?.data === 'string' ? JSONParse(aesDecrypt(res.data)) : null;
        } catch (e) {
          resData = null;
        }

        if (!resData) {
          return reject();
        }

        const { error, content, ...others } = resData;

        if (typeof error !== 'undefined') {
          return reject(resData);
        }

        if (content) {
          if (content !== 'EOF') {
            handleResponse({
              ...others,
              start: index === 0,
              done: false,
              content
            });
          } else {
            handleResponse({ ...others, start: false, done: true });
            index = 0;
            resolve(true);
          }
          index += 1;
        }
      },
      onerror: (err) => {
        index = 0;
        reject(err);
      },
      ...options
    }).catch((err) => {
      index = 0;
      reject(err);
    });
  });

/**
 * 历史记录
 * @param {object} params
 * @param {Array} params.messages 消息体
 * @returns
 */
export const historyList = (params) => {
  return get('/v1/plant/historyList', params);
};

/**
 * 授时
 * @param {object} params
 * @returns
 */
export const timeStamp = (params) => {
  return get('/v1/tool/timeStamp', params);
};

/**
 * 登录
 * @param {object} params
 * @returns
 */
export const feedback = (params) => {
  const formData = new FormData();

  for (const key in params) {
    const value = params[key];
    try {
      // 更严格的类型检查
      if (value !== 'undefined' && value !== undefined && value !== null) {
        // 处理特殊类型
        if (value instanceof File || value instanceof Blob) {
          formData.append(key, value);
        } else if (typeof value === 'object') {
          // 对象类型转换为字符串
          formData.append(key, JSON.stringify(value));
        } else {
          // 基本类型直接添加
          formData.append(key, String(value));
        }
      }
    } catch (error) {
      console.warn(`处理参数 ${key} 时出错:`, error);
      // 跳过错误的参数，继续处理其他参数
      continue;
    }
  }

  return post('/v1/feedback/add', formData, { requestType: 'form' });
};

/**
 * 邮箱上报
 * @param {object} params
 * @param {string} params.email 邮箱
 * @returns
 */
export const contact = (params) => {
  const formData = new FormData();

  for (const key in params) {
    const value = params[key];
    try {
      // 更严格的类型检查
      if (value !== 'undefined' && value !== undefined && value !== null) {
        // 处理特殊类型
        if (value instanceof File || value instanceof Blob) {
          formData.append(key, value);
        } else if (typeof value === 'object') {
          // 对象类型转换为字符串
          formData.append(key, JSON.stringify(value));
        } else {
          // 基本类型直接添加
          formData.append(key, String(value));
        }
      }
    } catch (error) {
      console.warn(`处理参数 ${key} 时出错:`, error);
      // 跳过错误的参数，继续处理其他参数
      continue;
    }
  }

  return post('/v1/aichat/contact', formData, { requestType: 'form' });
};

/**
 * 谷歌登录
 * @param {object} params
 * @param {string} params.googleIdToken token
 * @returns
 */
export const googleLogin = (params) => {
  const formData = new FormData();

  for (const key in params) {
    const value = params[key];
    try {
      // 更严格的类型检查
      if (value !== 'undefined' && value !== undefined && value !== null) {
        // 处理特殊类型
        if (value instanceof File || value instanceof Blob) {
          formData.append(key, value);
        } else if (typeof value === 'object') {
          // 对象类型转换为字符串
          formData.append(key, JSON.stringify(value));
        } else {
          // 基本类型直接添加
          formData.append(key, String(value));
        }
      }
    } catch (error) {
      console.warn(`处理参数 ${key} 时出错:`, error);
      // 跳过错误的参数，继续处理其他参数
      continue;
    }
  }

  return post('/v1/aichat/passport/googleLogin', formData, { requestType: 'form' });
};

/**
 * Facebook登录
 * @param {object} params
 * @param {string} params.shortToken token
 * @param {string} params.facebookUserId token
 * @param {string} params.username token
 * @returns
 */
export const facebookLogin = (params) => {
  const formData = new FormData();

  for (const key in params) {
    const value = params[key];
    try {
      // 更严格的类型检查
      if (value !== 'undefined' && value !== undefined && value !== null) {
        // 处理特殊类型
        if (value instanceof File || value instanceof Blob) {
          formData.append(key, value);
        } else if (typeof value === 'object') {
          // 对象类型转换为字符串
          formData.append(key, JSON.stringify(value));
        } else {
          // 基本类型直接添加
          formData.append(key, String(value));
        }
      }
    } catch (error) {
      console.warn(`处理参数 ${key} 时出错:`, error);
      // 跳过错误的参数，继续处理其他参数
      continue;
    }
  }

  return post('/v1/aichat/passport/facebookLogin', formData, { requestType: 'form' });
};
/**
 * 重置密码-发送验证码
 * @param {object} params
 * @returns
 */
export const sendCaptchaCode = (params) => {
  return get('/v1/aichat/user', params);
};
/**
 * 验证码提交
 * @returns
 */
export const resetPassword = (params) => {
  const formData = new FormData();

  for (const key in params) {
    const value = params[key];
    try {
      // 更严格的类型检查
      if (value !== 'undefined' && value !== undefined && value !== null) {
        // 处理特殊类型
        if (value instanceof File || value instanceof Blob) {
          formData.append(key, value);
        } else if (typeof value === 'object') {
          // 对象类型转换为字符串
          formData.append(key, JSON.stringify(value));
        } else {
          // 基本类型直接添加
          formData.append(key, String(value));
        }
      }
    } catch (error) {
      console.warn(`处理参数 ${key} 时出错:`, error);
      // 跳过错误的参数，继续处理其他参数
      continue;
    }
  }

  return post(`/v1/aichat/user/${params.captcha}`, formData, { requestType: 'form' });
};
/**
 * 查询域名配置
 * @param {*} params
 * @param {*} params.type 1 域名全局配置
 * @returns
 */
export const getConfig = (params) => get('/v1/aichat/home/getConfig', params);

/**
 * fb上报
 * @param {object} params
 * @param {string} params.did
 * @returns
 */
export const pushFbcid = (params) => {
  return post('/v1/aichat/fbcid/info', { ...params });
};
/**
 * 用户反馈
 * @param {object} params
 * @param {string} params.qusetion 文字
 * @param {string} params.attachment 图片
 * @param {string} params.contact 联系方式
 * @returns
 */
export const appFeedback = (params) => {
  const formData = new FormData();

  for (const key in params) {
    const value = params[key];
    try {
      // 更严格的类型检查
      if (value !== 'undefined' && value !== undefined && value !== null) {
        // 处理特殊类型
        if (value instanceof File || value instanceof Blob) {
          formData.append(key, value);
        } else if (typeof value === 'object') {
          // 对象类型转换为字符串
          formData.append(key, JSON.stringify(value));
        } else {
          // 基本类型直接添加
          formData.append(key, String(value));
        }
      }
    } catch (error) {
      console.warn(`处理参数 ${key} 时出错:`, error);
      // 跳过错误的参数，继续处理其他参数
      continue;
    }
  }
  return post('/v1/aichat/home/appFeedback', formData, { requestType: 'form' });
};
/**
 * 查询用户反馈字段配置
 */
export const getContactInfo = (params) => get('/v1/aichat/home/getContactInfo', params);
/**
 * 当前账户是否存在vip
 */
export const getCurIsVip = (params) => get('/v1/aichat/account/bind/attemptBind', params);

/**
 * 当前账户是否存在vip2
 */
export const getCurIsVip2 = (params) => get('/v1/aichat/account/bind/attemptBindV2', params);

/**
 * 查询高级功能配置
 */
export const getFuncConfig = (params) => get('/v1/aichat/home/funcResource', params);
/**
 * 激活码确定
 * @returns
 */
export const activeCode = (params) => {
  return post('/v1/aichat/account/bind/fillActiveCode', params);
};

/**
 * 查询退款信息
 */
export const getSubInfo = (params) => get(`/v1/aichat/center/pay/latest/order/${params.type}`, {});
/**
 * 订阅-取消订阅
 * @param {object} params
 * @param {string} params.did
 * @returns
 */
export const cancelSub = (params) => {
  return post('/v1/aichat/center/pay/cancel', { ...params });
};
/**
 * 积分-退款
 * @param {object} params
 * @param {string} params.did
 * @returns
 */
export const goReFund = (params) => {
  let url = '/v1/aichat/center/pay/refund';
  if (params?.reason) {
    url = `/v1/aichat/center/pay/refund?type=${params.type}&reason=${params.reason}`;
  }
  return post(url, { ...params });
};
/**
 * 查询支付跳转地址
 */
// export const getPayUrl = (params) => get(`/v1/airwallex/order/domain?account=${params.account}`, {});
export const getPayUrl = (params) => get(`/v1/airwallex/order/domain/v2`, {});
/**
 * 加密货币支付
 * @returns
 */
export const cryptoPay = (params) => {
  return post('/v1/now/payment/order', { ...params });
};
/**
 * 判断是否为信任用户
 * @returns
 */
export const checkTrust = (params) => {
  return get('/v1/aichat/trustfulLogo/check', { ...params });
};
/**
 * apppCode 绑定
 * @returns
 */
export const appCodeBind = (params) => {
  return postForm('/v1/aichat/app/redeemCode/bind', { ...params });
};
/**
 * 判断是否需要弹出vipcode框
 */
export const getVipReCode = (params) => get('/v1/aichat/app/redeemCode/check', params);
/**
 * 移除模糊
 */
export const getHD = (params) => {
  let url = `/v1/aichat/aigc/indisposed/getHD/unlock/${params.taskId}/${params.type}`;

  return post(url, { ...params });
};
/**
 * 查询当前任务所属价格
 */
export const getPrice = (params) => {
  let url = `/v1/aichat/aigc/indisposed/coin/${params.taskId}/${params.type}`;

  return post(url, { ...params });
};
/**
 * 查询服务器时间戳
 * @returns
 */
export const getTimeStamp = (params) => {
  return get('/v1/tool/timeStamp', { ...params });
};
